module.exports = __webpack_public_path__ + "img/hash_global.40d79db0.png";